import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../../reducers';

export const getLiteralsState = createSelector(getDragonflySharedState, (state) => state.literals);

export const getSystemSave = createSelector(getLiteralsState, ({ literals }) => literals['system.save']);

export const getSystemCancel = createSelector(getLiteralsState, ({ literals }) => literals['system.cancel']);

export const getUpdate = createSelector(getLiteralsState, ({ literals }) => literals['liquid.system.update']);

export const getSystemValidate = createSelector(getLiteralsState, ({ literals }) => literals['system.validate']);

export const getSystemSearchFilters = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.system.searchfilters'],
);

export const getSystemSelectValue = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.system.selectvalue'],
);

export const getSystemClear = createSelector(getLiteralsState, ({ literals }) => literals['system.clear']);

export const getSystemCreateNew = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.system.createnew'],
);

export const getSystemSearch = createSelector(getLiteralsState, ({ literals }) => literals['system.search']);

export const getSystemCouponSet = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.system.couponset'],
);

export const getSystemSure = createSelector(getLiteralsState, ({ literals }) => literals['system.sure']);

export const getAboutDeactivate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.message.youareaboutodeactivate'],
);

export const getSystemNo = createSelector(getLiteralsState, ({ literals }) => literals['system.no']);

export const getSystemYes = createSelector(getLiteralsState, ({ literals }) => literals['system.yes']);

export const getSystemNoResultsFound = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.system.noresultsfound'],
);

export const getSystemDelete = createSelector(getLiteralsState, ({ literals }) => literals['system.delete']);

export const getSystemInputValidation = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.validation.required'],
);

export const getSystemEmailValidation = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.validation.email.pattern'],
);

export const getSystemSaveSuccess = createSelector(getLiteralsState, ({ literals }) => literals['system.savesuccess']);

export const getSystemSaveFailed = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.validation.update.failed'],
);

export const getSystemGridFailed = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.system.campaign.error'],
);

export const getSystemClose = createSelector(getLiteralsState, ({ literals }) => literals['liquid.system.close']);

export const getUpdateIntegration = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.integrations.updateconfig'],
);

export const getFile = createSelector(getLiteralsState, ({ literals }) => literals['liquid.system.file.chosen']);

export const getSize = createSelector(getLiteralsState, ({ literals }) => literals['liquid.dashboard.size']);

export const getUploadedFileEmpty = createSelector(
  getLiteralsState,
  ({ literals }) => literals['member.utilities.unsubscribe.uploadedfileempty'],
);

export const getAttribute = createSelector(getLiteralsState, ({ literals }) =>
  literals['liquid.system.attribute'].toLowerCase(),
);

export const getUploadingFile = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.wizard.what.uploadingfile'],
);

export const getSystemCreate = createSelector(getLiteralsState, ({ literals }) => literals['liquid.system.create']);

export const getSystemAssign = createSelector(getLiteralsState, ({ literals }) => literals['liquid.system.assign']);

export const getCreateList = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.neaadhoclistmodal.createlist'],
);

export const getSubmit = createSelector(getLiteralsState, ({ literals }) => literals['system.buttons.submit']);

export const getUID = createSelector(getLiteralsState, ({ literals }) => literals['system.uid']);

export const getEmailValidation = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.validation.email.pattern'],
);

export const getJsonEditor = createSelector(getLiteralsState, ({ literals }) => literals['system.jsoneditor']);

export const getUploadFile = createSelector(getLiteralsState, ({ literals }) => literals['system.promo.uploadfile']);

export const getInvalidValue = createSelector(getLiteralsState, ({ literals }) => literals['system.invalidvalue']);
